var SortEnum = /* @__PURE__ */ ((SortEnum2) => {
  SortEnum2["SORT_BY_UNSPECIFIED"] = "SORT_BY_UNSPECIFIED";
  SortEnum2["SORT_BY_PUBLISH_AT"] = "SORT_BY_PUBLISH_AT";
  SortEnum2["SORT_BY_PRICE"] = "SORT_BY_PRICE";
  SortEnum2["SORT_BY_MOST_VIEW"] = "SORT_BY_MOST_VIEW";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY"] = "SORT_BY_TOP_SALE_QUANTITY";
  SortEnum2["SORT_BY_DISCOUNT_PERCENT"] = "SORT_BY_DISCOUNT_PERCENT";
  SortEnum2["SORT_BY_MOST_VIEW_3_DAYS"] = "SORT_BY_MOST_VIEW_3_DAYS";
  SortEnum2["SORT_BY_MOST_VIEW_7_DAYS"] = "SORT_BY_MOST_VIEW_7_DAYS";
  SortEnum2["SORT_BY_MOST_VIEW_30_DAYS"] = "SORT_BY_MOST_VIEW_30_DAYS";
  SortEnum2["SORT_BY_MOST_VIEW_90_DAYS"] = "SORT_BY_MOST_VIEW_90_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_3_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_3_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_7_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_7_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_30_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_30_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_90_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_90_DAYS";
  SortEnum2["SORT_BY_SCORE"] = "SORT_BY_SCORE";
  SortEnum2["SORT_BY_NAME"] = "SORT_BY_NAME";
  return SortEnum2;
})(SortEnum || {});
var OrderEnum = /* @__PURE__ */ ((OrderEnum2) => {
  OrderEnum2["ORDER_BY_UNSPECIFIED"] = "ORDER_BY_UNSPECIFIED";
  OrderEnum2["ORDER_BY_ASCENDING"] = "ORDER_BY_ASCENDING";
  OrderEnum2["ORDER_BY_DESCENDING"] = "ORDER_BY_DESCENDING";
  return OrderEnum2;
})(OrderEnum || {});

export { OrderEnum, SortEnum };
